import {ServerApi} from "../../api.js";
import {handleFetchError} from "../../helpers/functions.js";
import {TrailersPage} from "./TrailersPage.js";
import JSX from "../../helpers/react.js";


let loadedAnimeIds = new Set();

$(document).on('click', '.trailers-tab', showTrailers)

$(function () {
    if (document.querySelector(".trailers-tab")?.classList?.contains('active')) showTrailers();
})

async function showTrailers() {
    if (!loadedAnimeIds.has(page_id)) {
        loadedAnimeIds.add(page_id)
        try {
            const el = document.getElementById('trailers');
            if (el!.dataset['banned'] === '1') {
                el!.innerText = '';
                el!.appendChild(<BannedContent/>);
                return;
            }
            const trailers = await ServerApi.anime.trailers.get(page_id!);
            const element = (
                <TrailersPage trailers={trailers}/>
            );
            el!.innerText = '';
            el!.appendChild(element);
            $(element).find("select").slimSelect();
        } catch (e) {
            loadedAnimeIds.delete(page_id)
            handleFetchError(e);
        }
    }
}


function BannedContent() {
    return (
        <div className="error-notification status-bg alert-bg bordered">
            Трейлеры заблокированы.
        </div>
    )
}